import type {Middleware} from '@linx-security/api-specs';
import type {Logger} from 'pino';
import pino from 'pino';

export const baseLogger = pino({
  level: process.env.LOG_LEVEL || `info`,
});

// TODO: move to api package
// TODO: add "pino-http"
// TODO: print this logs to the browser console as well in development
export const getLogMiddleware = (base: Logger = baseLogger) => {
  const logger = base.child({module: `api`, scope: `fetch-middleware`}, {});

  return {
    pre: async context => {
      logger.debug(`API Request ${context.url}`, context.init);

      return context;
    },
    post: async context => {
      const {response} = context;
      logger.debug(response, `API Response ${context.url}`);
      // Try Print the response body if it's not a 2xx status code
      try {
        if (!response.ok) {
          const body = context.response.headers.get(`content-type`)?.includes(`json`)
            ? await response
                .clone()
                .json()
                .catch(async () => {
                  logger.warn(`Failed to parse response body as JSON`);
                  return await response.text();
                })
            : await response
                .clone()
                .text()
                .catch(() => {
                  logger.warn(`Failed to parse response body as text`);
                  return ``;
                });

          body && logger.error(`API Response Body: ${JSON.stringify(body)}`);
        }
      } catch (error) {
        logger.warn(`Failed to parse response body: ${error}`);
      }
      return context.response;
    },
  } satisfies Middleware;
};
